import config from '../config';

const LOG_LEVELS = {
  DEBUG: 'DEBUG',
  INFO: 'INFO',
  WARN: 'WARN',
  ERROR: 'ERROR',
};

class Logger {
  constructor() {
    this.enabled = config.app.enableLogging;
    this.environment = config.app.environment;
  }

  _formatMessage(level, message, data = null) {
    const timestamp = new Date().toISOString();
    const prefix = `[${timestamp}] [${level}]`;
    
    if (data) {
      return { prefix, message, data };
    }
    return { prefix, message };
  }

  _sendToExternalService(level, message, data) {
    if (this.environment === 'production') {
    }
  }

  debug(message, data = null) {
    if (!this.enabled) return;
    this._formatMessage(LOG_LEVELS.DEBUG, message, data);
  }

  info(message, data = null) {
    if (!this.enabled) return;
    this._formatMessage(LOG_LEVELS.INFO, message, data);
  }

  warn(message, data = null) {
    this._formatMessage(LOG_LEVELS.WARN, message, data);
    this._sendToExternalService('warning', message, data);
  }

  error(message, error = null) {
    this._formatMessage(LOG_LEVELS.ERROR, message, error);
    this._sendToExternalService('error', message, error);
  }

  apiRequest(method, url, payload = null) {
    this.debug(`API Request: ${method} ${url}`, payload);
  }

  apiResponse(method, url, status, data = null) {
    this.debug(`API Response: ${method} ${url} - ${status}`, data);
  }

  apiError(method, url, error) {
    this.error(`API Error: ${method} ${url}`, error);
  }

  userAction(action, details = null) {
    this.info(`User Action: ${action}`, details);
  }

  performance(metric, value) {
    this.debug(`Performance: ${metric} = ${value}ms`);
  }
}

const logger = new Logger();
export default logger;

